export const NEXA_USAGE_DASHBOARD_URL = '/app/nexa/conversation?open=nexa-usage-dashboard';
